import { Inject, Injectable } from '@angular/core';
import { isNil } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

@Injectable({ providedIn: 'root' })
export class Materials_ds_allocation_strategy_workflows_ddService {

  constructor(
    private $utils: UtilsService,
    private $settings: SettingsValuesService,
    ) { 
  }

  public async get(inParams: { is_active?: boolean, full_text_search?: string }): 
  Promise<{ result: { Id?: string, Name?: string }[] }> 
  {
    let url = `${environment.backendUrl}api/Materials/datasources/ds_allocation_strategy_workflows_dd/get`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.$utils.http.post(url, body, options);
    
  }
  public async getList(inParams: { is_active?: boolean, full_text_search?: string, $top?: number, $skip?: number }): 
  Promise<{ result: { Id?: string, Name?: string }[], totalCount: number }> 
  {
    let url = `${environment.backendUrl}api/Materials/datasources/ds_allocation_strategy_workflows_dd/getList`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.$utils.http.post(url, body, options);
    
  }
  public async getByKeys(inParams: { is_active?: boolean, full_text_search?: string, $keys: string[] }): 
  Promise<{ result: { Id?: string, Name?: string }[] }> 
  {
    const missingRequiredInParams = [];
    if (isNil(inParams.$keys)) {
      missingRequiredInParams.push('\'$keys\'');
    }
    if (missingRequiredInParams.length) {
    }
    let url = `${environment.backendUrl}api/Materials/datasources/ds_allocation_strategy_workflows_dd/getByKeys`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.$utils.http.post(url, body, options);
    
  }


    
    hasMissingRequiredInParams(inParams: { 
      is_active?: boolean, full_text_search?: string    }) {
      return false;
    }
}
